// Mobx
import { action, computed, observable } from "mobx";

// Api
import { Api } from "#/api";

// RootStore
import { Store } from "#/store";
import { ModelSelectionFilter } from "#/common/interfaces/model_selection/ModelSelectionFilter";

// Models

export class ModelSelectionFilterState {
  @computed
  public get selectedFilterId() {
    if (!this.selectedFilter) return "";

    return (
      this.selectedFilter.sparte +
      this.selectedFilter.gueltigkeiten.slice().sort().join("")
    );
  }

  @observable
  public selectedFilter?: ModelSelectionFilter;

  @observable
  public isSelectionModuleOpen: boolean = false;

  // RootStore
  public rootStore: Store;

  public constructor(store: Store) {
    this.rootStore = store;
  }

  @action.bound
  public handleToggleSelectionModule() {
    this.isSelectionModuleOpen = !this.isSelectionModuleOpen;
  }
}
